const schema = () => {
  return {
    title: 'Button Row Block',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [
          'preHeader',
          'title',
          'text',
          'backgroundColor',
          'backgroundImage',
          'isFullWidth',
          'alignment',
          'buttonsPosition',
          'useTOC',
          'useH2',
          'useH3',
          'displayAsList',
          'smallButtons',
          'buttons',
          'customClass',
        ],
      },
    ],
    properties: {
      preHeader: {
        title: 'Pre-header',
        type: 'string',
      },
      title: {
        title: 'Title',
        type: 'string',
      },
      text: {
        title: 'Text',
        type: 'string',
        widget: 'textarea',
      },
      backgroundColor: {
        title: 'Background colour',
        widget: 'select',
        choices: [
          ['#fff', 'White'],
          ['var(--green)', 'Green'],
          ['var(--flogreen)', 'Light Green'],
          ['var(--darkgreen)', 'Dark Green'],
          ['var(--grey)', 'Grey'],
          ['#000', 'Black'],
        ],
        default: '#f5f5f5',
      },
      backgroundImage: {
        title: 'Background image',
        widget: 'object_browser',
        mode: 'image',
        allowExternals: false,
      },
      isFullWidth: {
        title: 'Full width background',
        type: 'boolean',
        default: false,
      },
      alignment: {
        title: 'Text alignment',
        widget: 'align',
        actions: ['left', 'center', 'right'],
        default: 'left',
      },
      buttonsPosition: {
        title: 'Buttons position',
        widget: 'select',
        choices: [
          ['below', 'Below content'],
          ['beside', 'Beside content (right)'],
        ],
        default: 'below',
      },
      useTOC: {
        title: 'Use TOC instead of buttons',
        type: 'boolean',
        default: false,
      },
      useH2: {
        title: 'Include H2 headings in TOC',
        type: 'boolean',
        default: true,
      },
      useH3: {
        title: 'Include H3 headings in TOC',
        type: 'boolean',
        default: true,
      },
      displayAsList: {
        title: 'Display buttons as simple list',
        type: 'boolean',
        default: false,
      },
      smallButtons: {
        title: 'Use smaller buttons',
        type: 'boolean',
        default: false,
      },
      buttons: {
        title: 'Buttons',
        widget: 'object_list',
        schema: {
          title: 'Button',
          fieldsets: [
            {
              id: 'default',
              title: 'Default',
              fields: ['label', 'link', 'buttonStyle'],
            },
          ],
          properties: {
            label: {
              title: 'Label',
              type: 'string',
            },
            link: {
              title: 'Link',
              widget: 'object_browser',
              mode: 'link',
              allowExternals: true,
              multi: false,
              default: null,
            },
            buttonStyle: {
              title: 'Button style',
              widget: 'select',
              choices: [
                ['white-outline', 'White outline'],
                ['white-filled', 'White filled'],
                ['black-outline', 'Black outline'],
                ['black-filled', 'Black filled'],
                ['primary-outline', 'Primary outline'],
                ['primary-filled', 'Primary filled'],
              ],
              default: 'default',
            },
          },
        },
      },
      customClass: {
        title: 'Custom CSS class',
        type: 'string',
        description: 'Add a custom CSS class to this block',
      },
    },
    required: [],
  };
};

export default schema;
